import { Count } from '../../../../shared/components';
import { useResources } from '../../resources.context';

export const PendingApprovalCount = () => {
  const {
    pendingApproval: { isLoading, noCount, count },
  } = useResources();

  return (
    <Count
      title="Pending Approval"
      isLoading={isLoading}
      noCount={noCount}
      count={count}
    />
  );
};
